<template>
    <div>
      <modal size="large">
        <div slot="header" v-if="detailedPlayer">
            <div class="row columns">
              <h3>Customisation de Joueur :</h3>
            </div>
            <div class="row columns">
                n°{{detailedPlayer.num}} : "{{detailedPlayer.name}}" - {{detailedPlayer.ref_roster_line}}
            </div>
        </div>
        <div slot="body" v-if="detailedPlayer">
            <ul class="tabs horizontal" data-tab>
                <li @click="activatedTab = 1"><a :class="{activated : activatedTab === 1}">Stats</a></li>
                <li @click="activatedTab = 2"><a :class="{activated : activatedTab === 2}">Compétences</a></li>
                <li @click="activatedTab = 3"><a :class="{activated : activatedTab === 3}">Action, Xp, & Blessures</a></li>
                <li @click="activatedTab = 4"><a :class="{activated : activatedTab === 4}">Prix</a></li>
                <li @click="activatedTab = 5"><a :class="{activated : activatedTab === 5}">Xp gratuits</a></li>
            </ul>
            <br>
                <div :hidden="activatedTab !== 1">
                    <statsCustomizer :detailedPlayer="detailedPlayer" ref="statsCustomizer"></statsCustomizer>
                </div>
                <div :hidden="activatedTab !== 2">
                    <skillCustomizer :detailedPlayer="detailedPlayer" ref="skillCustomizer"></skillCustomizer>
                </div>
                <div :hidden="activatedTab !== 3">
                    <xpCustomizer :detailedPlayer="detailedPlayer" ref="xpCustomizer"></xpCustomizer>
                </div>
                <div :hidden="activatedTab !== 4">
                    <costCustomizer :detailedPlayer="detailedPlayer" ref="costCustomizer"></costCustomizer>
                </div>
                <div :hidden="activatedTab !== 5">
                  <freeXpCustomizer :detailedPlayer="detailedPlayer" ref="freeXpCustomizer"></freeXpCustomizer>
                </div>
        </div>
        <div slot="footer" class="panel-footer" >
            <div class="row columns">
                <div class="note text-centered">Validez lorsque vous avez modifié tout ce que vous voulez</div>
                <button class="large-4 light-grey-button" @click="$emit('closeMessage')">Annuler</button>
                <button class="large-4 large-offset-2" @click="showModal()"> valider</button>
            </div>
            <br>
        </div>
      </modal>
      <confirmModal v-if="showConfirmModal"
                    :customisations="customisations"
                    :visibilities="custoVisibilities"
                    @confirm="createCustomizations()"
                    @closeMessage="showConfirmModal=false"></confirmModal>
      <messageModal v-if="showCreatedModal" message="Vos customizations ont été enregistrées !" @closeMessage="showCreatedModal=false"></messageModal>
    </div>
</template>
<script>
import modal from '../../common/modal.vue'
import messageModal from '../../common/message-modal.vue'
import store from '../../../store/index.js'
import statsCustomizer from './stats-customizer.vue'
import skillCustomizer from './skills-customizer.vue'
import xpCustomizer from './xp-customizer.vue'
import costCustomizer from './cost-customizer.vue'
import freeXpCustomizer from './free-xp-customizer.vue'
import { mapGetters } from 'vuex'
import confirmModal from './customisation-confirm-modal'
import playerCustomization from '../../../api/player-customization.api'

export default {
  name: 'playerCustomizeStatsModal',
  components: {
    modal,
    statsCustomizer,
    skillCustomizer,
    costCustomizer,
    freeXpCustomizer,
    xpCustomizer,
    confirmModal,
    messageModal
  },
  props: {
    'playerId': Number
  },
  watch: {
    detailedPlayer: function (newVal, oldVal) {
      console.log('playerLoaded')
    },
    addedSkills: function (newVal, oldVal) {
      console.log('added skills modified')
    },
    activatedTab: function (newVal, oldVal) {
      if (newVal === 4) {
        this.customisations.skills = this.$refs.skillCustomizer.addedSkills
        console.log(this.customisations)
      }
    }
  },
  data () {
    return {
      activatedTab: 1,
      customisations: {},
      custoVisibilities: {
        stats: false,
        skills: false,
        xp: false,
        cost: true
      },
      showConfirmModal: false,
      showCreatedModal: false
    }
  },
  computed:
  {
    ...mapGetters([
      'detailedPlayer'])
  },
  methods: {
    getCustomisations () {
      this.customisations = {}
      this.custoVisibilities.stats = false
      this.custoVisibilities.skills = false
      this.custoVisibilities.xp = false
      this.customisations.player = this.detailedPlayer.id
      if (this.$refs.freeXpCustomizer.isUsed()) {
        this.custoVisibilities.free_xp = true
        this.customisations.free_xp = +this.$refs.freeXpCustomizer.free_xp
      }
      if (this.$refs.statsCustomizer.isUsed()) {
        this.custoVisibilities.stats = true
        this.customisations.M = +this.$refs.statsCustomizer.M_offset
        this.customisations.F = +this.$refs.statsCustomizer.F_offset
        this.customisations.Ag = +this.$refs.statsCustomizer.Ag_offset
        this.customisations.Ar = +this.$refs.statsCustomizer.Ar_offset
      }
      if (this.$refs.skillCustomizer.isUsed()) {
        this.custoVisibilities.skills = true
        this.customisations.skills = this.$refs.skillCustomizer.addedSkills
      }
      if (this.$refs.xpCustomizer.isUsed()) {
        this.custoVisibilities.xp = true
        if (this.$refs.xpCustomizer.action.nb_pass === '') {
          this.customisations.nb_pass = 0
        } else {
          this.customisations.nb_pass = +this.$refs.xpCustomizer.action.nb_pass
        }
        if (this.$refs.xpCustomizer.action.nb_td === '') {
          this.customisations.nb_td = 0
        } else {
          this.customisations.nb_td = +this.$refs.xpCustomizer.action.nb_td
        }
        if (this.$refs.xpCustomizer.action.nb_int === '') {
          this.customisations.nb_int = 0
        } else {
          this.customisations.nb_int = +this.$refs.xpCustomizer.action.nb_int
        }
        if (this.$refs.xpCustomizer.action.nb_cas === '') {
          this.customisations.nb_cas = 0
        } else {
          this.customisations.nb_cas = +this.$refs.xpCustomizer.action.nb_cas
        }
        if (this.$refs.xpCustomizer.action.nb_mvp === '') {
          this.customisations.nb_mvp = 0
        } else {
          this.customisations.nb_mvp = +this.$refs.xpCustomizer.action.nb_mvp
        }
        if (this.$refs.xpCustomizer.action.nb_foul === '') {
          this.customisations.nb_foul = 0
        } else {
          this.customisations.nb_foul = +this.$refs.xpCustomizer.action.nb_foul
        }
        if (this.$refs.xpCustomizer.action.nb_pass === '') {
          this.customisations.nb_niggling = 0
        } else {
          this.customisations.nb_niggling = +this.$refs.xpCustomizer.action.nb_niggling
        }
      }
      this.customisations.additionnal_cost = this.$refs.costCustomizer.cost / 1000
    },
    showModal () {
      this.getCustomisations()
      this.showConfirmModal = true
    },
    createCustomizations () {
      playerCustomization.api.createPlayerCustomization(this.customisations)
      .then(response => {
        this.showConfirmModal = false
        this.showCreatedModal = true
        this.$emit('closeMessage')
        this.$store.dispatch('reloadDetailedTeam')
      },
      error => {
        console.log('erreur impossible to create customizations')
        console.log(error)
      })
    }
  },
  mounted () {
    store.dispatch('invalidateSkillList')
    store.dispatch('getDetailedPlayer', this.playerId)
  },
  created () {
    store.dispatch('getUpgradeToBeDoneForPlayer', this.playerId)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

.large-btn-icon {
  font-size: 0.8rem;
}

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tbody.large-font tr td{
    padding: 0.3rem 0.2rem;
    text-align: center;
    font-size:1.1rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}

.large-font {
  font-size: 1.1rem
}
.button-column {
  text-align: right;
}

.tabs {
    border-style: none;
    padding-top: 1.2rem;
    border-bottom: 1px solid #cacaca;
    padding-bottom: 0.4rem
}


.tabs li{
    float: left;
    margin-left : 0rem;
    /* padding : 0.4rem 0.8rem ; */
    margin-right : 0rem;
    /* position: relative; */
    bottom: -1px;
    margin-bottom:0rem;
}

.tabs li a {
    color:#596374;
    font-weight: 400;
    transition: background-color 0.5s,border-top-color 0.5s;
    padding : 0.4rem 0.8rem ;
}

.tabs > li a:hover {
    border-top: 2px solid #2c3e50;
}

.tabs > li a.activated {
    border: 1px solid #cacaca;
    border-bottom: 3px solid white;
    border-top: 2px solid #2c3e50;
    position: relative;
}

.note {
  font-size: 0.8rem;
  margin-bottom: 0.6rem;
}
</style>



// WEBPACK FOOTER //
// player-customize-modal.vue?093132cd